import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	menuItem: {
		color: tokens.colorNeutralForeground3,
		paddingLeft: "14px",
		paddingRight: "20px",
		width: "100%",
		...shorthands.borderRadius("0"),
		"&>span:first-child": {
			marginRight: "6px",
		},
	},
	popoverContent: {
		minWidth: "190px",
		...shorthands.padding("6px", "0px"),
		...shorthands.border("none"),
	},
});
